exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ws-status{position:absolute;font-size:.6rem;bottom:22px;right:5px}", ""]);

// exports
